import FuseAnimate from '@fuse/core/FuseAnimate';
import { Button, FormControl, Stack, Switch, Typography } from '@mui/material';
import customStyles from 'app/shared-components/SelectCustomStyle';
import React, { useRef, useState, useEffect } from 'react'
import Select from 'react-select';


const CalendarMeeting = (props) => {
    const formRef = useRef(null);
    const [years, setYears] = useState('')
    const [toggled, setToggled] = React.useState(false);
    const { changeYear, selectedYear } = props;
    useEffect(() => {
        let currentYears = new Date().getFullYear()
        let allYears = [];
        for (let i = 0; i < 10; i++) {
            allYears.push({
                label: currentYears,
                value: currentYears
            })
            currentYears -= 1;
        }
        console.log('currentYears', "currentYears")
        setYears(allYears)
        changeYear(allYears[1])
    }, [])
    return (
        <FuseAnimate delay={500}>
            <div className="flex container">
                <FormControl
                    ref={formRef}
                    className="flex flex-row"
                    sx={{ ml: '24px' }}>
                    <div>
                        {/* <Select name="year"
                            placeholder="Select Year"
                            value={selectedYear}
                            className="select yearStyle"
                            classNamePrefix="select"
                            onChange={changeYear}
                            options={years}
                            // menuIsOpen={!!years.length}
                            getOptionLabel={e => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    {e.icon}
                                    <span style={{ marginLeft: 5 }}>{e.label}</span>
                                </div>
                            )}
                            styles={customStyles()}
                        /> */}
                    </div>
                    {/* <div className='ml-20'>
                        <Stack direction="row" alignItems="center" className='w-auto'>
                                <Typography>SITE VISIT</Typography>
                                <Switch
                                    // classes={switchStyles}
                                    checked={toggled}
                                    onChange={e => setToggled(e.target.checked)}
                                />
                                <br />
                                <Typography>REQUEST A MEETING</Typography>
                        </Stack>
                    </div> */}
                </FormControl>
			<Typography variant='h6' color='#f1c40f'  className='ml-30'>Select Date and Time to create site visit/request meeting</Typography>
            </div>
        </FuseAnimate>
    )
}

export default CalendarMeeting